import { cn } from "@/libs/cn";
import { isBurmese } from "@/libs/language";

interface PageTitleProps extends React.HTMLAttributes<HTMLHeadingElement> {
	children: React.ReactNode;
}

export function PageTitle({ children, ...props }: PageTitleProps) {
	return (
		<h2
			{...props}
			className={cn(
				"text-2xl font-semibold text-primary-gradient font-poppins ",
				props.className,
				{ "text-xl leading-9": isBurmese(children as string) },
			)}
		>
			{children}
		</h2>
	);
}
